import React, { Component } from 'react'
import { Calendar ,Alert} from 'antd';
import moment from 'moment';
import 'antd/dist/antd.css';
import './calendar.less';
// 推荐在入口文件全局设置 locale
import 'moment/locale/zh-cn';

moment.locale('zh-cn');
let mcData = [];
let isClickable =false;
function getListData(value) {
  let listData;
  let ftime=value.format('YYYY-MM-DD');
  for (let variable of mcData) {
    if(variable.examdate === ftime)
    {
      let ca=variable.islocked || (!variable.isShow && variable.noUsedCount === 0 ) || variable.noUsedCount === 0 ?'unvalid':'valid';
      let cb=variable.noUsedCount === 0 ? '已满' :'余'+variable.noUsedCount;
      let desc=variable.islocked ?'休息': !variable.isShow ? variable.noUsedCountName : cb;
      listData ={ type:ca, content:desc };
      break;
    }
}
  return listData || [];
}

function dateFullCellRender(value)
{
   const listData = getListData(value);
  let firstm=(value.month()+1)+'月';
  return(<div>
    <div className="ant-fullcalendar-value">
     {
       value.date()===1? <span className='piao'>{firstm}</span>:''
     }
      {value.date()}
   
  </div>
  <div className="ant-fullcalendar-content">
       <div className="events">
      {
        <div className={listData.type}>       
        {listData.content}</div>
      }
    </div>
    </div>
  </div>    

  );
}
export default class AddCalendar extends Component {
  constructor(props) {
    super(props);   
  
    mcData=this.props.cm;
    isClickable=this.props.isClickable;
  }
    onPanelChange(value, mode) {
    
    }
    state = {
      value: moment(new Date()),
      selectedValue: moment(new Date()),
      tm:'',
    };

    onSelect = value => {
      let ftime=value.format('YYYY-MM-DD');
      let dd = mcData.find((p) => p.examdate === ftime && p.islocked === false); 
      if(dd === undefined  || dd.noUsedCount === 0)
      { 
      this.setState({
        tm:'该时间不允许预约'
      });
      }else{      
        this.setState({
          tm:''
        });    
        if(isClickable)
        {
          this.props.new.getChildData(this,ftime);
        }    
       
      }
      this.setState({
        value,
        selectedValue: value,
      });
    };

    onPanelChange = value => {    
      this.setState({ value });
    };
   
    render() {      
      const { value,selectedValue,tm } = this.state;
      return (
        <div style={{ width: '100%', border: '1px solid #d9d9d9', borderRadius: 4 ,}}>
         <Alert
            message={`${selectedValue && selectedValue.format('YYYY-MM-DD')}${tm}`}
          />
          <Calendar fullscreen={false}  dateFullCellRender={dateFullCellRender} value={value} onSelect={this.onSelect} onPanelChange={this.onPanelChange} />,
          
      </div>
      );
    }

  }